import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScissors } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import DownloadButton from './DownloadButton';
import ShareButton from './ShareButton';
import styles from './styles.module.css';
import BBBResourceButton from '../BBBResourcesLayouts/BBBResourceButton';
import { getCode } from '../../../store/params/selectors';

interface Props {
  show: boolean;
  clipModeActive: boolean;
  open: () => void;
  bbbResourcesLength: number;
}

const SideButtons = ({ show, clipModeActive, open, bbbResourcesLength }: Props): JSX.Element => {
  const [showBBBResourceButton, setShowBBBResourceButton] = useState(true);
  const [translationType, setTranslationType] = useState<string | undefined>(undefined);

  const container = `${styles.container} ${clipModeActive && styles.containerClipModeActive} ${
    !show && styles.containerHide
  }`;

  const clipIconClass = `${styles.clipIcon} ${clipModeActive && styles.clipIconShow}`;

  const code = useSelector(getCode);

  useEffect(() => {
    let detectedType: string | undefined;
    const lowerCode = code?.toLowerCase();

    if (/bbb|aslv|islv/i.test(lowerCode || '')) {
      detectedType = 'bbb';
    } else if (lowerCode?.includes('cbt')) {
      detectedType = 'cbt';
    }

    setTranslationType(detectedType);
  }, [code]);

  useEffect(() => {
    setShowBBBResourceButton(translationType === 'bbb');
  }, [translationType]);

  return (
    <div className={container}>
      <ShareButton />
      <DownloadButton />
      {showBBBResourceButton && bbbResourcesLength > 0 && <BBBResourceButton onClick={open} />}
      <FontAwesomeIcon className={clipIconClass} icon={faScissors} />
    </div>
  );
};

export default SideButtons;
